import { VisitAndAppointmentView } from '@dreryk/egabinet-visit-frontend-api';

import { Button } from '@dreryk/react-components';

import { VisitCancelShowModalEventInterceptor } from '~libs.desktop.shared.visit-cancel';

import { appointmentsTranslationKeys } from '../../../../translations';
import { RefetchAppointments } from '../../../appointments.types';

type CancelAppointmentButtonProps = Pick<VisitAndAppointmentView, 'appointmentId' | 'cancellable'> & {
   readonly refetchAppointments: RefetchAppointments;
};

export const CancelAppointmentButton = (props: CancelAppointmentButtonProps): JSX.Element => {
   return (
      <VisitCancelShowModalEventInterceptor
         cancellable={props.cancellable}
         appointmentId={props.appointmentId}
         onSuccess={props.refetchAppointments}
         onFault={props.refetchAppointments}
      >
         <Button
            label={appointmentsTranslationKeys.cancelPlannedAppointment}
            disabled={!props.cancellable}
            testId={'cancelAppointment'}
         />
      </VisitCancelShowModalEventInterceptor>
   );
};
